const details = {
    name: "نی نی کار تویز",
    enName: "shop",
    description: "پخش و فروش تک و عمده ماشین و موتور شارژی",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    }
}

export default details;
